import messageCreateComponent from './message.create.component';

let messageCreateModule = angular.module('messagecreate', [
  ])

  .component('messagecreate', messageCreateComponent)

  .name;

export default messageCreateModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/create/index.js